export default __webpack_public_path__ + "static/media/facebook-circled-shake.26bec6f6.gif";